import { Alert } from '@mui/material';
import { FC } from 'react';

interface IProps {
  severity: 'error' | 'info' | 'success' | 'warning';
  message: string;
}

const CustomAlert: FC<IProps> = ({ severity, message }) => <Alert severity={severity}>{message}</Alert>;

export default CustomAlert;
